import React, { useCallback, useEffect } from 'react'
import ContentAddButton from './ContentAddButton'
import Pagination from '../Pagination'
import ContentRow from './ContentRow'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { authenticated } from '../../recoil/auth'
import { contentCurrentPage, contentData, contentDeleted, contentLoading, contentMessage } from '../../recoil/content'
import { domainWeb } from '../../config/constants'
import axios from 'axios'
import WaitingText from '../WaitingText'

const ContentListTable = (props) => {
    const auth = useRecoilValue(authenticated);
    const [loading, setLoading] = useRecoilState(contentLoading);
    const [contents, setContents] = useRecoilState(contentData);
    const [currentPage, setCurrentPage] = useRecoilState(contentCurrentPage);
    const setMessage = useSetRecoilState(contentMessage);
    const deleted = useRecoilValue(contentDeleted);

    const getContentsData = useCallback(async () => {
        setLoading(true);
        setMessage({});
        console.debug(deleted);
        try {
            let url = `${domainWeb}/contents?page=${currentPage}`;
            let response = await axios.get(url, {
                headers: {
                    'Content-Type': 'application/json', 
                    'Accept': 'application/json', 
                    'Authorization': 'Bearer ' + auth.token
                }
            });
            setContents(response.data);
            setLoading(false);
        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    }, [auth.token, currentPage, deleted, setContents, setLoading, setMessage]);

    useEffect(() => {
        getContentsData();
    }, [getContentsData]);

    const loadData = () => {
        if (loading || contents.data === undefined) {
            return <div className="p-3"><WaitingText/></div>;
        }
        if (contents.data.length === 0) {
            return <div className="p-3">Tidak ada data.</div>;
        }
        return (
            <div>
                {
                    contents.data.map((item, i) => <ContentRow key={i} data={item} clickDelete={props.clickDelete} />)
                }
            </div>
        );
    };

    const changePage = (page) => {
        setCurrentPage(page);
    };

    return (
        <div className="bg-white rounded-lg shadow">
            <div className="flex items-center justify-between px-8 py-5">
                <h3 className="text-xl font-semibold">Daftar Konten</h3>
                <ContentAddButton />
            </div>
            <div className="flex items-center gap-5 px-8 py-3">
                <div className="w-1/5">Tanggal</div>
                <div className="w-1/2">Judul</div>
                <div className="w-1/12">Dokumen</div>
                <div className="w-1/12">Video</div>
                <div className="w-1/12">Soal Kuis</div>
                <div className="w-14">Aksi</div>
            </div>
            <div className="w-full border"></div>
            <div className="px-5 py-3">
                {loadData()}
            </div>
            <div className="w-full border"></div>
            <div className="flex justify-end gap-5 px-8 py-3">
                <Pagination currentPage={contents.page} maxPage={contents.max_page} changePage={changePage}/>
            </div>
        </div>
    )
}

export default ContentListTable